<template>
  <div class="Container">
    <Card :title="title" class="p-text-center p-m-2">
      <div class="icon" v-if="$slots.icon">
        <slot name="icon"></slot>
      </div>
      <img class="img" v-else-if="icon" :src="icon" />
      <p>{{message}}</p>
      <slot name="action"></slot>
    </Card>
  </div>
</template>

<script>
import Card from "./Card";
export default {
  props: {
    title: String,
    message: String,
    icon: [String, Object],
  },
  components: { Card },
};
</script>
<style scoped>
/* .img,
.icon {
  width: 120px;
  height: 120px;
  margin: 20px 10px;
} */
.icon {
  display: inline-block;
  font-size: 120px;
  color: #777;
}
</style>